/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Messaging_Bots_Payments_Desc8Inputs */

const en_svc_messaging_bots_payments_desc8 = /** @type {(inputs: Svc_Messaging_Bots_Payments_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collect payment in chat and sync every conversation to your CRM and sheets.`)
};

const ar_svc_messaging_bots_payments_desc8 = /** @type {(inputs: Svc_Messaging_Bots_Payments_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حصّل الدفع داخل المحادثة وزامن كل محادثة مع CRM وجداول البيانات.`)
};

const bn_svc_messaging_bots_payments_desc8 = /** @type {(inputs: Svc_Messaging_Bots_Payments_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`চ্যাটের ভেতরেই পেমেন্ট নিন আর প্রতিটি কথোপকথন CRM ও শিটে সিঙ্ক করুন।`)
};

const de_svc_messaging_bots_payments_desc8 = /** @type {(inputs: Svc_Messaging_Bots_Payments_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlung im Chat einziehen und jedes Gespräch mit CRM und Tabellen synchronisieren.`)
};

const es_svc_messaging_bots_payments_desc8 = /** @type {(inputs: Svc_Messaging_Bots_Payments_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cobrar en el chat y sincronizar cada conversación con su CRM y sus hojas de cálculo.`)
};

const fr_svc_messaging_bots_payments_desc8 = /** @type {(inputs: Svc_Messaging_Bots_Payments_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encaissez dans le chat et synchronisez chaque conversation avec votre CRM et vos tableurs.`)
};

const pt_svc_messaging_bots_payments_desc8 = /** @type {(inputs: Svc_Messaging_Bots_Payments_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Receba no chat e sincronize cada conversa com o seu CRM e folhas de cálculo.`)
};

const zh_svc_messaging_bots_payments_desc8 = /** @type {(inputs: Svc_Messaging_Bots_Payments_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在聊天内收款，并把每次对话同步到你的 CRM 和表格。`)
};

const tr_svc_messaging_bots_payments_desc8 = /** @type {(inputs: Svc_Messaging_Bots_Payments_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sohbet içinde tahsilat yapın, her konuşmayı CRM ve tablolarınızla senkronize edin.`)
};

const ru_svc_messaging_bots_payments_desc8 = /** @type {(inputs: Svc_Messaging_Bots_Payments_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Принимайте оплату в чате и синхронизируйте каждый диалог с вашей CRM и таблицами.`)
};

const pl_svc_messaging_bots_payments_desc8 = /** @type {(inputs: Svc_Messaging_Bots_Payments_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zbieraj płatność w czacie i synchronizuj każdą rozmowę z CRM i arkuszami.`)
};

/**
* | output |
* | --- |
* | "Collect payment in chat and sync every conversation to your CRM and sheets." |
*
* @param {Svc_Messaging_Bots_Payments_Desc8Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_messaging_bots_payments_desc8 = /** @type {((inputs?: Svc_Messaging_Bots_Payments_Desc8Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Messaging_Bots_Payments_Desc8Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_messaging_bots_payments_desc8(inputs)
	if (locale === "bn") return bn_svc_messaging_bots_payments_desc8(inputs)
	if (locale === "de") return de_svc_messaging_bots_payments_desc8(inputs)
	if (locale === "es") return es_svc_messaging_bots_payments_desc8(inputs)
	if (locale === "fr") return fr_svc_messaging_bots_payments_desc8(inputs)
	if (locale === "pt") return pt_svc_messaging_bots_payments_desc8(inputs)
	if (locale === "zh") return zh_svc_messaging_bots_payments_desc8(inputs)
	if (locale === "tr") return tr_svc_messaging_bots_payments_desc8(inputs)
	if (locale === "ru") return ru_svc_messaging_bots_payments_desc8(inputs)
	if (locale === "pl") return pl_svc_messaging_bots_payments_desc8(inputs)
	return en_svc_messaging_bots_payments_desc8(inputs)
});
export { svc_messaging_bots_payments_desc8 as "svc_messaging-bots_PAYMENTS_desc" }